import { createI18n } from 'vue-i18n'

import { locales } from '@last/core-ui/paprika'

import en from '@/locales/en.json'
import es from '@/locales/es.json'

export const availableLocales = ['en', 'es']

export default createI18n({
  locale: 'es',
  fallbackLocale: 'es',
  globalInjection: true,
  legacy: false,
  availableLocales,
  messages: {
    en: {
      ...locales.en,
      ...en
    },
    es: {
      ...locales.es,
      ...es
    }
  }
})
